import React from 'react';
import { NavigationWrapper } from '../shared/NavigationWrapper';
import { NavigationItems } from '../shared/NavigationItems';
import SecondaryNavigation from '../shared/SecondaryNavigation';
import { useGetWebsiteDetails } from '../hooks/useSiteSectionDetails';

interface IProps {
	isSticky: boolean;
	className?: string;
}

export default function DesktopNavigation({ isSticky, className }: IProps) {
	const { currentSiteSection, menuItems } = useGetWebsiteDetails();

	return (
		<NavigationWrapper
			className={className}
			isSticky={isSticky}
			isDesktop
			secondary={<SecondaryNavigation />}
		>
			{currentSiteSection && menuItems && <NavigationItems />}
		</NavigationWrapper>
	);
}
